import { ChangeDetectorRef, Component, OnInit,Output, EventEmitter } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap';
import { ExceptionHelper } from '../../../../helper';
import { CustomerSiteSummaryService, CustomerSummaryService } from '../../customer';
import { EquipmentSummaryService } from '../equipment-summary/equipment-summary.service';
import { IsActive} from './../../../../model';
@Component({
  selector: 'app-equipment-copy',
  templateUrl: './equipment-copy.component.html',
  styleUrls: ['./equipment-copy.component.css']
})
export class EquipmentCopyComponent implements OnInit {

  form = this.fb.group({
    equipmentId: ['', [Validators.required]],
    quantity: ['', [Validators.max(10), Validators.min(0)]],
    customerId: [''],
    siteId: [''],
  });


  dropdownSettingsCustomer = {};
  dropdownSettingsEquipment = {};
  dropdownSettings = {};
  customerId: FormControl;

  siteId: any;
  equipmentId: any;
  redirect = true;
  selectedCustomerName = '';
  selectedCustomerShortName = '';
  selectedSiteName = '';

  selectedIds: number[];

  selectedEquipmentName = '';
  selectedEquipmentIds: number[];
  customers = [];
  sites = [];
  equipments = [];
  bsModalRef: BsModalRef;

  constructor(private router: Router, private route: ActivatedRoute, private fb: FormBuilder,
    private customerSummaryService: CustomerSummaryService,
    private customerSiteSummaryService: CustomerSiteSummaryService,
    private exception: ExceptionHelper,    
    private equipmentSummaryService: EquipmentSummaryService,
    private chRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.getCustomerSummary()
    this.getEquipmentSummary()

    this.selectedIds = [];

    this.dropdownSettingsCustomer = {
      singleSelection: true,
      text: 'Select Customer',
      enableSearchFilter: true,
      labelKey: 'shortName',
      enableFilterSelectAll: false,
      showCheckbox: false
    };


    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Site',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'locationShort',
      showCheckbox: false
    };
 

    this.dropdownSettingsEquipment = {
      singleSelection: true,
      text: 'Select Equiqment',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'equipmentIdName',
      showCheckbox: false
    };
  }

  submit() {
    console.log(this.form.value['siteId']); 
    if (this.form.valid) {
      const siteId = this.form.value['siteId'].length != 0 ? this.form.value['siteId'][0].id : ""
      this.equipmentSummaryService.copy(this.form.value['equipmentId'][0].equipmentId, this.form.value['quantity'], siteId).subscribe((data: any) => {
      
        this.router.navigate(['/home/equipment']);
      
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
    }
  }

  getEquipmentSummary() { 
    this.equipmentSummaryService.getSummary(null, null, IsActive.active)
      .subscribe((data: any) => {
        this.equipments = data.equipmentListModel;
        $('div.c-btn').attr('equipmentId', 'single-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      }, () => {
        this.chRef.detectChanges();
      });
  }
  getCustomerSummary(): void {
    this.customerSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.customers = data.customerListModel;
        for (const customer of this.customers) {
          if (customer.id == this.customerId) {
            this.form.controls['customerId'].setValue([customer]);
            this.selectedCustomerName = customer.name;
            this.selectedCustomerShortName = customer.shortName;
            this.getSiteSummary(customer.id);
          }
        }
        $('div.c-btn').attr('id', 'single-select');
      }, error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
      }, () => {
        this.chRef.detectChanges();
      });
  }

  getSiteSummary(customerId): void {
    this.customerSiteSummaryService.getSummary(customerId, IsActive.active)
      .subscribe((data: any) => {
        this.sites = data.siteListModel;
        $('div.c-btn').attr('id', 'single-select');
      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
        });
  }

  public closeSuccessModel(): void {
    this.router.navigate(['/home/equipment']);
  }

  public onCloseSite(items: any) {
    
  }
  public onCloseEquipment(items: any) {
    if (this.form.value.equipmentId.length === 0) {
      this.form.controls['equipmentId'].setErrors({'required': true});
    }
  }


  onSiteSelect(item: any) {
    this.selectedSiteName = item.locationShort;
  }
  

  onEquipmentSelect(item: any) {
    this.selectedEquipmentName = item.equipmentId;
  }

  onCustomerSelect(item: any) {
    this.customerId = item.id;
    // clear site input
    this.form.controls['siteId'].setValue([]);
    // get customer site summary
    if (this.customerId) {
      this.getSiteSummary(this.customerId);
    }
    this.selectedCustomerName = item.name;
    this.selectedCustomerShortName = item.shortName;
  }

  onCustomerDeselect(item: any) {
    // clear site input
    this.form.controls['siteId'].setValue([]);
    // clear site options
    this.sites = [];
  }


  public onClose(items: any) {

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-copy/equipment-copy.component.ts